import React, { useEffect, useState } from 'react'
import { ScrollView, Text, useWindowDimensions, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { useDispatch, useSelector } from 'react-redux';
import { ImageComp } from '../../../components/Image/Image';
import Loader from '../../../components/Loader/loader';
import { formatDate } from '../../../js/formatDate';
import { useTranslation } from 'react-i18next';
import { formatLocalTime, getStyleForRenderHTML } from '../../../js/utility';
import CustomPressable from '../../../components/customPressable/customPressable';
import InfoPopupModal from '../../../components/infoPopupModal';
import { cancelRestaurantReservation } from '../../../Redux/Actions/tableReservationAction';
import { getCleanUrl, toBool } from '../../../utils/Helper';
import { setRenderFlashMessage } from '../../../Redux/Actions/appConfigAction';
import { TABLE_RESERVATION_CATEGORY } from '../../../config/Constant';
import { sendAnalytics } from '../../../Redux/Actions/analyticsAction';
import { CROSS, EDIT } from '../../../assets';
import RenderHTML from 'react-native-render-html';

const MyReservations = (props) => {
    const { selectedVenue, tableReservationSessionToken, setEditReservation, handleRefreshMyReservations, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {width} = useWindowDimensions()

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { myReservations } = useSelector(state => state.tableReservationSlice);
    const TIME_FORMAT = useSelector(state => state.deviceConfigSlice?.extraConfigParam?.TIME_FORMAT_MERIDIEM) || false;

    const [groupedMyReservationData, setGroupMyReservationData] = useState(new Map());
    const [myReservationDataAsPerVenue, setMyreservationDataAsPerVenue] = useState([]);

	const [cancelReservationId, setCancelReservationId] = useState(null);
    const [loading, setLoading] = useState(false);
    


    const groupingByDate = (data) => {
		const groupedAccToDay = new Map();

		data.sort((a, b) => {
			return new Date(a.real_datetime_of_slot).getTime() - new Date(b.real_datetime_of_slot).getTime()
		})
		data.forEach((d) => {
			const groupingKey = d.date;
			if (groupedAccToDay.has(groupingKey)) {
				const keyData = groupedAccToDay.get(groupingKey);
				keyData.push(d);
			} else {
				groupedAccToDay.set(groupingKey, [d]);
			}
		});

		return groupedAccToDay;
	};

    const filterBySelectedVenue = (myReservationData) => {

		let requiredVenueData = [];

		myReservationData.forEach((singleReservationData) => {
			if(!selectedVenue.id || selectedVenue.id == ""){
				requiredVenueData.push(singleReservationData);
			} else {
				if(singleReservationData.venue_id == selectedVenue.id){
					requiredVenueData.push(singleReservationData);
				}
			}
		})

		return requiredVenueData;
	}

    const handleCancelReservation = async () => {
        setLoading(true);

        try {
            const response = await dispatch(cancelRestaurantReservation(cancelReservationId));
            if(response?.status == 200){
                dispatch(setRenderFlashMessage(true, { type: "success", message: t('reservations.deleted_success') }))
                setCancelReservationId(null);
                handleRefreshMyReservations();
                dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "DELETE RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": 1 }));
                
            } else {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: response?.data?.header?.status?.msg || "Something went wrong" }))
                dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "DELETE RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": 1, "errorMessage": response?.data?.header?.status?.msg || "Something went wrong" }));
            }
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status?.msg || error?.message || "Something went wrong"
            dispatch(setRenderFlashMessage(true, { type: "danger", message: errorMessage }))

            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "DELETE RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": 1, "errorMessage": errorMessage }));
        } finally {
            setLoading(false)
        }

    }


    useEffect(() => {
		if(myReservationDataAsPerVenue?.length > 0) setGroupMyReservationData(groupingByDate(myReservationDataAsPerVenue));


        // eslint-disable-next-line react-hooks/exhaustive-deps
	},[myReservationDataAsPerVenue])

    useEffect(() => {
        if(myReservations?.myReservationData?.length){
            setMyreservationDataAsPerVenue(filterBySelectedVenue(myReservations?.myReservationData));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
	},[myReservations?.myReservationData])

    console.log("currentWidget", currentWidget)

    const customWidgetTitleStyle = getStyles([
        'sevenRoomsMyReservationWidgetDescription',
        `sevenRoomsMyReservationWidgetDescription_${currentWidget?.widgetMetaHtmlId}`,
        `sevenRoomsMyReservationWidgetDescription_${currentWidget?.id}`
    ]);

    const { baseStyle: titleBaseStyle, systemFonts: titleSystemFonts } = getStyleForRenderHTML(customWidgetTitleStyle);

    return (
        <View style={getStyles(['widgetRootContainer', 'sevenRoomsMyReservationRootContainer', `sevenRoomsMyReservationRootContainer_${currentWidget.widgetMetaHtmlId}`])} id={`widgetRootContainer sevenRoomsMyReservationRootContainer sevenRoomsMyReservationRootContainer_${currentWidget.widgetMetaHtmlId}`}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'sevenRoomsMyReservationMainContainer', `sevenRoomsMyReservationMainContainer_${currentWidget.widgetMetaHtmlId}`])} 
                showsVerticalScrollIndicator={false}
                id={`sevenRoomsMyReservationMainContainer sevenRoomsMyReservationMainContainer_${currentWidget.widgetMetaHtmlId}`}
            >
                {/* Details  */}
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'sevenRoomsMyReservationHeaderContainer', `sevenRoomsMyReservationHeaderContainer_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationHeaderContainer sevenRoomsMyReservationHeaderContainer_${currentWidget.widgetMetaHtmlId}`}>
                    {currentWidget?.widgetHeaderImageUrl && <ImageComp source={getCleanUrl(currentWidget.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'sevenRoomsMyReservationHeaderImg', `sevenRoomsMyReservationHeaderImg_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationHeaderImg sevenRoomsMyReservationHeaderImg_${currentWidget.widgetMetaHtmlId}`}/>}

                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'sevenRoomsMyReservationMainPageHeaderTitleContainer', `sevenRoomsMyReservationMainPageHeaderTitleContainer_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationMainPageHeaderTitleContainer sevenRoomsMyReservationMainPageHeaderTitleContainer_${currentWidget.widgetMetaHtmlId}`}>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'sevenRoomsMyReservationHeaderTitle', `sevenRoomsMyReservationHeaderTitle_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationHeaderTitle sevenRoomsMyReservationHeaderTitle_${currentWidget.widgetMetaHtmlId}`}>
                            {selectedVenue?.name}
                        </Text>
                    </View>
                </View>
                
                <View style={getStyles((["widgetmainContainerChildContainer", "sevenRoomsMyReservationMainContainerChildContainer", `sevenRoomsMyReservationMainContainerChildContainer_${currentWidget.widgetMetaHtmlId}`]))}>
                    <CustomPressable style={getStyles(['primaryBtn', `primaryBtn_${currentWidget.widgetMetaHtmlId}`])} onPress={handleNext} id={`primaryBtn primaryBtn_${currentWidget.widgetMetaHtmlId}`}>
                        <Text style={getStyles(['primaryBtnTxt', 'sevenRoomsMyReservationPrimaryBtnTxt', `sevenRoomsMyReservationPrimaryBtnTxt_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationPrimaryBtnTxt sevenRoomsMyReservationPrimaryBtnTxt_${currentWidget.widgetMetaHtmlId}`}>{t('reservations.reserve_table')}</Text>
                    </CustomPressable>
                    
                    {currentWidget?.widgetDesc &&  
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={titleBaseStyle}
                            source={{ html: currentWidget?.widgetDesc }}
                            systemFonts={titleSystemFonts}
                            id={`sevenRoomsMyReservationWidgetDescription sevenRoomsMyReservationWidgetDescription_${currentWidget.widgetMetaHtmlId}`}
                        />
                    }


                    {
                        selectedVenue?.phone_number && 
                            <View style={getStyles(["textContainer", `textContainer_${currentWidget.widgetMetaHtmlId}`])} id={`textContainer textContainer_${currentWidget.widgetMetaHtmlId}`}>
                                <Text style={getStyles(["label", `label_${currentWidget.widgetMetaHtmlId}`])} id={`label label_${currentWidget.widgetMetaHtmlId}`}>{t('reservations.phone')}</Text>
                                <Text style={getStyles(["textValue", `textValue_${currentWidget.widgetMetaHtmlId}`])} id={`textValue textValue_${currentWidget.widgetMetaHtmlId}`}>{selectedVenue?.phone_number}</Text>
                            </View>
                    }

                    {
                        selectedVenue?.address && 
                            <View style={getStyles(["textContainer", `textContainer_${currentWidget.widgetMetaHtmlId}`])} id={`textContainer textContainer_${currentWidget.widgetMetaHtmlId}`}>
                                <Text style={getStyles(["label", `label_${currentWidget.widgetMetaHtmlId}`])} id={`label label_${currentWidget.widgetMetaHtmlId}`}>{t('reservations.location')}</Text>
                                <Text style={getStyles(["textValue", `textValue_${currentWidget.widgetMetaHtmlId}`])} id={`textValue textValue_${currentWidget.widgetMetaHtmlId}`}>{selectedVenue?.address}</Text>
                            </View>
                    }

                    {/* My Reservations */}
                    <View style={getStyles(["textContainer", `textContainer_${currentWidget.widgetMetaHtmlId}`])} id={`textContainer textContainer_${currentWidget.widgetMetaHtmlId}`}>
                        <Text style={getStyles(['label', `label_${currentWidget.widgetMetaHtmlId}`])} id={`label label_${currentWidget.widgetMetaHtmlId}`}>
                            {myReservations?.myReservationData?.length > 1 ? t("reservations.myReservations") : t("reservations.myReservation")}
                        </Text>

                        {myReservations?.loading ? <Loader style={getStyles(['crossOverContaniner_loader', `crossOverContaniner_loader_${currentWidget.widgetMetaHtmlId}`])} /> 
                            : myReservationDataAsPerVenue?.length > 0 ?
                                Array.from(groupedMyReservationData.entries()).map(([day, dataOnThatDay]) => {
                                    return (
                                        <View style={getStyles(["sevenRoomsMyReservationGroupContainer", `sevenRoomsMyReservationGroupContainer_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationGroupContainer sevenRoomsMyReservationGroupContainer_${currentWidget.widgetMetaHtmlId}`}>
                                            <Text style={getStyles(["sevenRoomsMyReservationGroupContainerTitle", `sevenRoomsMyReservationGroupContainerTitle_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationGroupContainerTitle sevenRoomsMyReservationGroupContainerTitle_${currentWidget.widgetMetaHtmlId}`}>{formatDate(day)}</Text>
                                            {dataOnThatDay.map((reservation) => {
                                                return (
                                                    <View style={getStyles(["list_itemContainer", "sevenRoomsMyReservationGroupContainerDetailsContainer", `sevenRoomsMyReservationGroupContainerDetailsContainer_${currentWidget.widgetMetaHtmlId}`])} id={`list_itemContainer sevenRoomsMyReservationGroupContainerDetailsContainer sevenRoomsMyReservationGroupContainerDetailsContainer_${currentWidget.widgetMetaHtmlId}`}>
                                                        <View style={getStyles(["list_itemContainer_textContainer", "sevenRoomsMyReservationGroupContainerDetailsTextContainer", `sevenRoomsMyReservationGroupContainerDetailsTextContainer_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationGroupContainerDetailsTextContainer sevenRoomsMyReservationGroupContainerDetailsTextContainer_${currentWidget.widgetMetaHtmlId}`}>
                                                            <Text style={getStyles(["list_itemContainer_textContainer_title", "sevenRoomsMyReservationGroupContainerDetailsContainerTitle", `sevenRoomsMyReservationGroupContainerDetailsContainerTitle_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationGroupContainerDetailsContainerTitle sevenRoomsMyReservationGroupContainerDetailsContainerTitle_${currentWidget.widgetMetaHtmlId}`}>{reservation.name}</Text>
                                                            <Text style={getStyles(["list_itemContainer_textContainer_subtitle", "sevenRoomsMyReservationGroupContainerDetailsContainerSubTitle", `sevenRoomsMyReservationGroupContainerDetailsContainerSubTitle_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationGroupContainerDetailsContainerSubTitle sevenRoomsMyReservationGroupContainerDetailsContainerSubTitle_${currentWidget.widgetMetaHtmlId}`}>
                                                                {formatLocalTime(new Date(reservation.real_datetime_of_slot), toBool(TIME_FORMAT))}
                                                            </Text>
                                                        </View>
                                                        
                                                        <View style={getStyles(["sevenRoomsMyReservationGroupContainerDetailsActionContainer", `sevenRoomsMyReservationGroupContainerDetailsActionContainer_${currentWidget.widgetMetaHtmlId}`, {flexDirection: "row", gap: 8}])} id={`sevenRoomsMyReservationGroupContainerDetailsActionContainer sevenRoomsMyReservationGroupContainerDetailsActionContainer_${currentWidget.widgetMetaHtmlId}`}>
                                                            {reservation.status == "CANCELED" ? (
                                                                <Text style={getStyles(["sevenRoomsMyReservationGroupContainerDetailsActionCancel", `sevenRoomsMyReservationGroupContainerDetailsActionCancel_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationGroupContainerDetailsActionCancel sevenRoomsMyReservationGroupContainerDetailsActionCancel_${currentWidget.widgetMetaHtmlId}`}>
                                                                    {reservation.status_display}
                                                                </Text>
                                                            ) 
                                                            : reservation.status == "NOT_RECONCILED" ? (
                                                                <>
                                                                    <CustomPressable
                                                                        onPress={() => {
                                                                            console.log("edit clicked", reservation)
                                                                            setEditReservation(reservation)
                                                                        }}
                                                                        style={getStyles(["sevenRoomsMyReservationGroupContainerDetailsActionEditContainer", `sevenRoomsMyReservationGroupContainerDetailsActionEditContainer_${currentWidget.widgetMetaHtmlId}`])}
                                                                        id={`sevenRoomsMyReservationGroupContainerDetailsActionEditContainer sevenRoomsMyReservationGroupContainerDetailsActionEditContainer_${currentWidget.widgetMetaHtmlId}`}
                                                                    >
                                                                        <ImageComp source={EDIT} style={getStyles(["sevenRoomsEditButton", `sevenRoomsEditButton_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsEditButton sevenRoomsEditButton_${currentWidget.widgetMetaHtmlId}`} />
                                                                    </CustomPressable>
                                                                    <CustomPressable
                                                                        onPress={() => setCancelReservationId(reservation?.id)}
                                                                        style={getStyles(["sevenRoomsMyReservationGroupContainerDetailsActionCancelContainer", `sevenRoomsMyReservationGroupContainerDetailsActionCancelContainer_${currentWidget.widgetMetaHtmlId}`])}
                                                                        id={`sevenRoomsMyReservationGroupContainerDetailsActionCancelContainer sevenRoomsMyReservationGroupContainerDetailsActionCancelContainer_${currentWidget.widgetMetaHtmlId}`}
                                                                    >
                                                                         <ImageComp 
                                                                            style={getStyles(['sevenRoomsCancelledButton', `sevenRoomsCancelledButton_${currentWidget.widgetMetaHtmlId}`])}
                                                                            id={`spaBookingCancelledButton spaBookingCancelledButton_${currentWidget.widgetMetaHtmlId}`}
                                                                            source={CROSS}
                                                                        />
                                                                    </CustomPressable>
                                                                </>
                                                            ) : (
                                                                <Text style={getStyles(["sevenRoomsMyReservationGroupContainerDetailsActionStatus", `sevenRoomsMyReservationGroupContainerDetailsActionStatus_${currentWidget.widgetMetaHtmlId}`])} id={`sevenRoomsMyReservationGroupContainerDetailsActionStatus sevenRoomsMyReservationGroupContainerDetailsActionStatus_${currentWidget.widgetMetaHtmlId}`}>
                                                                    {reservation.status_display}
                                                                </Text>
                                                            )}
                                                        </View>
                                                    </View>
                                                );
                                            })}
                                        </View>
                                    );
                                })
                            : <Text style={getStyles(['textValue', `textValue_${currentWidget.widgetMetaHtmlId}`])} id={`textValue textValue_${currentWidget.widgetMetaHtmlId}`}>
                                {t('reservations.no_reservatino_found')}
                            </Text>
                        }
                    </View>
                </View>

            </ScrollView>

            {/* <View style={getStyles(['sevenRoomsReservationDetails_button_container'])} id='sevenRoomsReservationDetails_button_container'>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleGoBack} id='primaryBtn'>
                    <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>{t('reservations.next')}</Text>
                </CustomPressable>
            </View> */}

            {cancelReservationId && <InfoPopupModal
                    title={t('reservations.cancel_reser.heading1')}
                    subtitle={t('reservations.cancel_reser.subHeading')} 
                    onContinue={handleCancelReservation}
                    disablePrimaryBtn={loading}
                    primaryBtnLabel={loading ? t('reservations.cancelling') : t('reservations.cancel')} 
                    onClose={() => setCancelReservationId(null)}
                    secondaryBtnLabel={t('reservations.close')}
                    OnRequestClose={() => setCancelReservationId(null)}
            />}

        </View>
    )
}

export default MyReservations